export const PathName = (...paths: string[]) => {
    return paths.join('/');
};

/**
 * Base Routes. Should be proceeded by a forward slash
 */
export enum AppRoutePaths {
    Admin = '/admin',
    Appointment = '/appointment',
    Customer = '/customer',
    Assets = '/assets',
    ImHere = '/im-here',
    OutdoorVehiclePickUp = '/outdoor-vehicle-pick-up',
    Landing = '/landing',
    ContinueSession = '/continue-session',
    VehiclePickUp = '/vehicle-pick-up',
    SaveSession = '/save-session',
    Accessibility = '/accessibility',
    OutdoorPickUp = '/outdoor-pick-up',
    OnlinePayment = '/online-payment',
    CheckInDetails = '/check-in-details',
    PickupQRCode = '/pick-up-qr-code'
}

// Subroutes

/**
 * /admin/*
 */
export enum AdminRoutePaths {
    /**
     * /admin/keymanagement
     */
    KeyManagement = 'keymanagement',
    /**
     * /admin/pin
     */
    Pin = 'pin',
    /**
     * /admin/identityverification
     */
    IdentityVerification = 'identityverification',
    /**
     * /admin/kioskinformation
     */
    KioskInformation = 'kioskinformation',
    /**
     * /admin/setuplogin
     */
    SetupLogin = 'setuplogin'
}

/**
 * /admin/keymanagement/*
 */
export enum Admin_KeyManagementRoutePaths {
    /**
     * /admin/keymanagement/appointmentdetails
     */
    AppointmentDetails = 'appointmentdetails',
    /**
     * /admin/keymanagement/create
     */
    CreateAppointment = 'create',
    /**
     * /admin/keymanagement/storekey
     */
    StoreKey = 'storekey',
    /**
     * /admin/keymanagement/lockeropen
     */
    LockerOpen = 'lockeropen',
    /**
     * /admin/keymanagement/contact
     */
    ContactInformation = 'contact'
}

/**
 * /admin/keymanagement/storekey/*
 */
export enum Admin_StoreKeyRoutePaths {
    /**
     * /admin/keymanagement/storekey/updatetotal
     */
    UpdateTotal = 'updatetotal',
    /**
     * /admin/keymanagement/storekey/placekey
     */
    Placekey = 'placekey',
    /**
     * /admin/keymanagement/storekey/complete
     */
    Complete = 'complete',
    /**
     * /admin/keymanagement/storekey/contact
     */
    ContactInformation = 'contact',
    /**
     * /admin/keymanagement/storekey/loaner-or-rental-return
     */
    LoanerOrRentalReturn = 'loaner-or-rental-return',
    /**
     * /admin/keymanagement/storekey/payment-check
     */
    PaymentCheck = 'payment-check',
}

/**
 * /appointment/*
 */
export enum AppointmentRoutePaths {
    /**
     * /appointment/details
     */
    Details = 'details',
    /**
     * /appointment/search
     * /appointment/search/phoneoremail
     */
    Search = 'search',
    /**
     * /appointment/customer
     */
    Customer = 'customer',
    /**
     * /appointment/confirm
     */
    Confirm = 'confirm',
    /**
     * /appointment/mileage
     */
    Mileage = 'mileage',
    /**
     * /appointment/vehicle
     */
    Vehicle = 'vehicle',
    /**
     * /appointment/hunter
     */
    Hunter = 'hunter',
    /**
     * /appointment/tagnumber
     */
    Tagnumber = 'tagnumber',
    /**
     * /appointment/signelectronically
     */
    SignElectronically = 'signelectronically',
    /**
     * /appointment/services-previously-added
     */
    ServicesPreviouslyAdded = 'services-previously-added',
    /**
     * /appointment/valuation
     */
    Valuation = 'valuation',
    /**
     * /appointment/recalls
     */
    Recalls = 'recalls',
    /**
     * /appointment/additional-services
     */
    AdditionalServices = 'additional-services',
    /**
     * /appointment/select-accessories
     */
    SelectAccessories = 'select-accessories',
    /**
     * /appointment/custom-service
     */
    CustomService = 'custom-service',
    /**
     * /appointment/xtime
     */
    Xtime = 'xtime',
    /**
     * /appointment/services
     */
    Services = 'services',
    /**
     * /appointment/transportation
     */
    Transportation = 'transportation',
    /**
     * /appointment/complete
     */
    Complete = 'complete',
    /**
     * /appointment/towincomplete
     */
    TowInComplete = 'towincomplete',
    /**
     * /appointment/disclaimertabs
     */
    DisclaimerTabs = 'disclaimertabs',
    /**
     * /appointment/summary
     */
    Summary = 'summary',
    /**
     * /appointment/towinadditionaldetails
     */
    TowInAdditionalDetails = 'towinadditionaldetails',
    /**
     * /appointment/keydrop
     */
    Keydrop = 'keydrop',
    /**
     * /appointment/survey1
     */
    Survey1 = 'survey1',
    /**
     * /appointment/survey2
     */
    Survey2 = 'survey2'
}

/**
 * /appointment/keydrop/*
 */
export enum Appointment_KeydropRoutePaths {
    /**
     * /appointment/keydrop/locker
     */
    Locker = 'locker',
    /**
     * /appointment/keydrop/option
     */
    Option = 'option',
    /**
     * /appointment/keydrop/advisor
     */
    Advisor = 'advisor',
    /**
     * /appointment/keydrop/doublecheck
     */
    DoubleCheck = 'doublecheck',
    /**
     * /appointment/keydrop/help
     */
    Help = 'help'
}

/**
 * /appointment/transportation/*
 */
export enum Appointment_TransportationRoutePaths {
    /**
     * /appointment/transportation/pickup
     */
    Pickup = 'pickup'
}

/**
 * /appointment/services/*
 */
export enum Appointment_ServiceRoutePaths {
    /**
     * /appointment/services/comments
     */
    Comments = 'comments',
    /**
     * /appointment/services/add
     */
    Add = 'add'
}

/**
 * /customer/*
 */
export enum CustomerRoutePaths {
    /**
     * /customer/lookup
     */
    Lookup = 'lookup',
    /**
     * /customer/add
     */
    Add = 'add'
}

/**
 * /customer/add/*
 */
export enum Customer_AddRoutesPaths {
    /**
     * /customer/add/towcompanydetails
     */
    TowCompanyDetails = 'towcompanydetails',
    /**
     * /customer/add/details
     */
    Details = 'details',
    /**
     * /customer/add/confirm
     */
    Confirm = 'confirm',
    /**
     * /customer/add/vehicle
     */
    Vehicle = 'vehicle',
    /**
     * /customer/add/vinscanmobile
     */
    VinScanMobile = 'vinscanmobile',
    /**
     * /customer/add/mileage
     */
    Mileage = 'mileage',
    /**
     * /customer/add/tagnumber
     */
    Tagnumber = 'tagnumber',
    /**
     * /customer/add/scan
     */
    Scan = 'scan',
    /**
     * /customer/add/customer-info
     */
    CustomerInfo = 'customer-info'
}

/**
 * /outdoor-vehicle-pick-up/*
 */
export enum OutdoorVehiclePickUpRoutePaths {
    /**
     * /outdoor-vehicle-pick-up/locker
     */
    Locker = 'locker',
    /**
     * /outdoor-vehicle-pick-up/appointment
     */
    Appointment = 'appointment',
    /**
     * /outdoor-vehicle-pick-up/doublecheck
     */
    DoubleCheck = 'doublecheck',
    /**
     * /outdoor-vehicle-pick-up/help
     */
    Help = 'help',
    /**
     * /outdoor-vehicle-pick-up/complete
     */
    Complete = 'complete',
    /**
     * /outdoor-vehicle-pick-up/advisor
     */
    Advisor = 'advisor'
}

/**
 * /pick-up-qr-code/*
 */
export enum PickUpQRCodeRoutePaths {
    /**
     * /pick-up-qr-code/appointment
     */
    Appointment = 'appointment',
    /**
     * /pick-up-qr-code/qr
     */
    QRCode = 'qr',
}

/**
 * /online-payment/*
 */
export enum OnlinePaymentRoutePaths {
    /**
     * /online-payment/appointment
     */
    LoadAppointment = 'appointment',
    /**
     * /online-payment/landing
     */
    Landing = 'landing',
    /**
     * /online-payment/payment
     */
    Payment = 'payment',
    /**
     * /online-payment/payment-status
     */
    PaymentStatus = 'payment-status'
}
/**
 * /check-in-details/*
 */
export enum CheckInDetailsRoutePaths {
    /**
     * /check-in-details/appointment
     */
    Appointment = 'appointment',
    /**
     * /check-in-details/landing
     */
    Landing = 'landing'
}
/**
 * /vehicle-pick-up/*
 */
export enum VehiclePickupRoutePaths {
    /**
     * /vehicle-pick-up/payment
     */
    Payment = 'payment',
    /**
     * /vehicle-pick-up/keydrop-pickup
     */
    KeydropPickup = 'keydrop-pickup',
    /**
     * /vehicle-pick-up/resend
     */
    Resend = 'resend',
    /**
     * /outdoor-vehicle-pick-up/double-check
     */
    DoubleCheck = 'double-check',
}

/**
 * /continue-session/*
 */
export enum ContinueSessionRoutePaths {
    /**
     * /continue-session/verify/appointment
     */
    VerifyAppointment = 'verify/appointment',
    /**
     * /continue-session/continue
     */
    Continue = 'continue',
    /**
     * /continue-session/resend
     */
    Resend = 'resend',
    /**
     * /continue-session/mileage
     */
    Mileage = 'mileage',
    /**
     * /continue-session/verify/details
     */
    VerifyDetails = 'verify/details',
    /**
     * /continue-session/tagnumber
     */
    TagNumber = 'tagnumber',
    /**
     * /continue-session/hunter
     */
    Hunter = 'hunter'
}
